module.exports = __webpack_public_path__ + "img/icon-exit-login.878d721b.svg";